import { Info } from 'lucide-react';
import { DeckardIconWrapper } from './DeckardIcon';

export const InfoIcon = DeckardIconWrapper({ Icon: Info });
